module.exports = __webpack_public_path__ + "static/media/header.731ebd8a.mp3";